export const createGameDetailsSlice = (props)=>(set, get)=>({
            gameDetails: {
                matchmakingMatchType: props.matchmakingMatchType,
                isRanked: props.isRanked,
                isDiscord: props.isDiscord,
                playOrder: props.playOrder,
                isCanvasFullWidth: props.isCanvasFullWidth
            }
        });
